'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { List, Map as ImmutableMap, OrderedMap, Seq } from 'immutable';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import I18n from 'I18n';
import classNames from 'classnames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import Branding from 'MeetingsBase/models/Branding';
import { getEvent } from 'MeetingsLib/selectors/BookInfoSelectors';
import { shadeColor } from 'MeetingsLib/utils/color';
import { getTextColor } from 'MeetingsBase/utils/color';
import { isDateInPast } from 'MeetingsBase/utils/dates';
import { UNAVAILABLE_REASONS } from 'MeetingsLib/constants/enums';
var DatePickerButton = createReactClass({
  displayName: "DatePickerButton",
  propTypes: {
    availableDates: PropTypes.instanceOf(Seq).isRequired,
    branding: PropTypes.instanceOf(Branding).isRequired,
    currentTime: PropTypes.number.isRequired,
    date: PropTypes.string.isRequired,
    daysToAdd: PropTypes.number.isRequired,
    handleSetEventDate: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    // troubleshoot mode
    bookableDates: PropTypes.instanceOf(List),
    configuredAvailabilityByDate: PropTypes.instanceOf(OrderedMap),
    editLinkURL: PropTypes.string.isRequired,
    troubleshootTimesForSelectedDurationByDay: PropTypes.instanceOf(ImmutableMap),
    minimumNoticeTimeBusyDays: PropTypes.instanceOf(List),
    isTroubleshooting: PropTypes.bool,
    userTimezone: PropTypes.string.isRequired
  },
  isValid: function isValid() {
    var _this$props = this.props,
        availableDates = _this$props.availableDates,
        date = _this$props.date;
    return availableDates.includes(date);
  },
  getClassNames: function getClassNames() {
    var selected = this.props.selected;
    var valid = this.isValid();
    return classNames('date-picker-btn', valid ? "valid" : "disabled", selected && "selected");
  },
  shouldTroubleshoot: function shouldTroubleshoot() {
    var _this$props2 = this.props,
        date = _this$props2.date,
        availableDates = _this$props2.availableDates,
        isTroubleshooting = _this$props2.isTroubleshooting;

    if (!isTroubleshooting) {
      return false;
    }

    var dayHasAvailability = availableDates.includes(date);
    return !dayHasAvailability;
  },
  getUnbookableReason: function getUnbookableReason() {
    var _this$props3 = this.props,
        bookableDates = _this$props3.bookableDates,
        configuredAvailabilityByDate = _this$props3.configuredAvailabilityByDate,
        currentTime = _this$props3.currentTime,
        date = _this$props3.date,
        troubleshootTimesForSelectedDurationByDay = _this$props3.troubleshootTimesForSelectedDurationByDay,
        minimumNoticeTimeBusyDays = _this$props3.minimumNoticeTimeBusyDays,
        userTimezone = _this$props3.userTimezone;

    if (!this.shouldTroubleshoot()) {
      return null;
    }

    if (isDateInPast(date, currentTime, userTimezone)) {
      return UNAVAILABLE_REASONS.PAST;
    }

    if (!bookableDates.includes(date)) {
      return UNAVAILABLE_REASONS.DATE_NOT_CONFIGURED;
    }

    if (!configuredAvailabilityByDate.get(date)) {
      return UNAVAILABLE_REASONS.TIME_NOT_CONFIGURED;
    }

    if (minimumNoticeTimeBusyDays.includes(date)) {
      return UNAVAILABLE_REASONS.MINIMUM_NOTICE;
    }

    var troubleshootTimesForDate = troubleshootTimesForSelectedDurationByDay.get(date);
    var overlapsWithDayLongEvent = troubleshootTimesForDate && troubleshootTimesForDate.find(function (troubleshotTime) {
      return troubleshotTime.reason === UNAVAILABLE_REASONS.ALL_DAY_EVENT;
    });

    if (overlapsWithDayLongEvent) {
      return UNAVAILABLE_REASONS.ALL_DAY_EVENT;
    }

    return null;
  },
  getStyle: function getStyle() {
    var _this$props4 = this.props,
        selected = _this$props4.selected,
        primaryColor = _this$props4.branding.primaryColor;
    var primaryTextColor = getTextColor(primaryColor);

    if (selected) {
      return {
        color: primaryColor,
        background: primaryTextColor
      };
    }

    if (this.shouldTroubleshoot() && this.getUnbookableReason()) {
      var shadedColor = shadeColor(primaryColor, 40);
      return {
        color: getTextColor(shadedColor),
        background: shadedColor
      };
    }

    return {
      color: primaryTextColor
    };
  },
  getTooltipText: function getTooltipText() {
    var editLinkURL = this.props.editLinkURL;
    var unbookableReason = this.getUnbookableReason();

    switch (unbookableReason) {
      case UNAVAILABLE_REASONS.PAST:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "troubleshoot.day.past"
        });

      case UNAVAILABLE_REASONS.DATE_NOT_CONFIGURED:
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "troubleshoot.day.customRange_jsx",
          options: {
            href: editLinkURL,
            external: true
          },
          elements: {
            Link: UILink
          }
        });

      case UNAVAILABLE_REASONS.TIME_NOT_CONFIGURED:
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "troubleshoot.day.unset_jsx",
          options: {
            href: editLinkURL,
            external: true
          },
          elements: {
            Link: UILink
          }
        });

      case UNAVAILABLE_REASONS.MINIMUM_NOTICE:
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "troubleshoot.day.minimum_jsx",
          options: {
            href: editLinkURL,
            external: true
          },
          elements: {
            Link: UILink
          }
        });

      case UNAVAILABLE_REASONS.ALL_DAY_EVENT:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "troubleshoot.day.dayLong"
        });

      default:
        return null;
    }
  },
  render: function render() {
    var _this$props5 = this.props,
        date = _this$props5.date,
        daysToAdd = _this$props5.daysToAdd,
        handleSetEventDate = _this$props5.handleSetEventDate,
        selected = _this$props5.selected;
    var placement = daysToAdd > 3 ? 'top left' : 'top right';
    var isValid = this.isValid();
    var tabIndex = isValid ? 0 : -1;
    var disabled = !isValid;

    var button = /*#__PURE__*/_jsx("td", {
      "data-selenium-test-disabled": disabled,
      children: /*#__PURE__*/_jsx("button", {
        "aria-controls": "available-times-region",
        "aria-pressed": selected,
        "aria-disabled": disabled,
        "aria-label": I18n.moment(date).format('MMMM Do'),
        tabIndex: tabIndex,
        id: selected ? 'selected-date' : '',
        style: this.getStyle(),
        onClick: function onClick() {
          return handleSetEventDate(date);
        },
        onKeyPress: function onKeyPress(e) {
          return e.key === 'Enter' && handleSetEventDate(date);
        },
        className: this.getClassNames(),
        children: /*#__PURE__*/_jsx("span", {
          children: I18n.moment(date).format('D')
        })
      })
    });

    if (!this.props.isTroubleshooting) {
      return button;
    }

    var tooltipText = this.getTooltipText();
    return /*#__PURE__*/_jsx(UITooltip, {
      disabled: !tooltipText,
      maxWidth: 210,
      placement: placement,
      title: tooltipText,
      use: "longform",
      children: button
    });
  }
});
export default connect(function (state, props) {
  return {
    selected: getEvent(state).dateString === props.date
  };
})(DatePickerButton);